module.exports = __webpack_public_path__ + "media/components/global/promos/redirector-app-notice/img/compfight-d02b313979bc603dec4db9e38908df6b.svg";